// Web landmark loader — same pattern as the mobile one. Imports the
// bundled JSON from common (single source of truth) and dispatches it
// into Redux synchronously. NO RTDB fetch on web either, eliminating
// the per-admin-session /landmarks egress entirely.
//
// Trade-off: admins see the snapshot bundled with the deployed web
// build until the next deploy. Refresh workflow:
//   1. Run import_addis_landmarks Cloud Function (Google Places import).
//   2. From repo root: `yarn export:landmarks` — pulls /landmarks into
//      common/src/data/landmarks.json.
//   3. `yarn web:deploy` to ship.

import bundledLandmarks from 'common/src/data/landmarks.json';
import { FETCH_LANDMARKS_SUCCESS } from 'common/src/store/types';
import {
  buildLandmarkIndex,
  searchLocal as _searchLocal,
  landmarkToAutocompleteShape,
} from 'common/src/other/landmarkSearch';

let _normalizedCache = null;
let _searchIndex = null;

const normalize = () => {
  if (_normalizedCache) return _normalizedCache;
  if (!bundledLandmarks || typeof bundledLandmarks !== 'object') {
    _normalizedCache = [];
    return _normalizedCache;
  }
  if (Array.isArray(bundledLandmarks)) {
    _normalizedCache = bundledLandmarks
      .filter(Boolean)
      .map((lm, i) => Object.assign({ id: (lm && lm.id) || ('lm_' + i) }, lm));
    return _normalizedCache;
  }
  _normalizedCache = Object.keys(bundledLandmarks).map((id) =>
    Object.assign({ id: id }, bundledLandmarks[id])
  );
  return _normalizedCache;
};

export const loadBundledLandmarks = (dispatch) => {
  const arr = normalize();
  if (dispatch) {
    dispatch({ type: FETCH_LANDMARKS_SUCCESS, payload: arr });
  }
  return arr;
};

// Local autocomplete — same API + shape as the mobile counterpart.
// See `mobile-app/src/utils/landmarks.js` searchLandmarks() doc-comment
// for the contract details.
export const searchLandmarks = (query, gps, limit = 8) => {
  if (!_searchIndex) {
    _searchIndex = buildLandmarkIndex(normalize());
  }
  const hits = _searchLocal(query, _searchIndex, gps, limit);
  return hits.map(landmarkToAutocompleteShape).filter(Boolean);
};
